
import { useCallback } from 'react';
import { Email } from '../types';
import { useEmailOperations } from '../hooks/useEmailOperations';

interface UseEmailContextOperationsProps {
  emails: Email[];
  stableSetEmails: (emails: Email[]) => void;
  stableSetCurrentEmail: (email: Email | null) => void;
  stableSetLoading: (loading: boolean) => void;
  stableSetError: (error: boolean) => void;
  stableSetStatistics: (stats: any) => void;
  stableSetHasMoreEmails: (hasMore: boolean) => void;
  stableSetTotalEmailsInFolder: (total: number) => void;
  stableSetTotalPages: (pages: number) => void;
  currentFolder: string;
}

export const useEmailContextOperations = ({
  emails,
  stableSetEmails,
  stableSetCurrentEmail,
  stableSetLoading,
  stableSetError,
  stableSetStatistics,
  stableSetHasMoreEmails,
  stableSetTotalEmailsInFolder,
  stableSetTotalPages,
  currentFolder,
}: UseEmailContextOperationsProps) => {
  
  const operations = useEmailOperations({
    emails,
    setEmails: stableSetEmails,
    setCurrentEmail: stableSetCurrentEmail,
    setLoading: stableSetLoading,
    setError: stableSetError,
    setStatistics: stableSetStatistics,
    setHasMoreEmails: stableSetHasMoreEmails,
    setTotalEmailsInFolder: stableSetTotalEmailsInFolder,
    setTotalPages: stableSetTotalPages,
    currentFolder,
  });

  const loadFolderEmails = useCallback(async (folder: string, limit: number = 25, page: number = 1, search?: string) => {
    await operations.fetchEmails(folder, limit, page, false, false, search); // Always replace, never append
  }, [operations.fetchEmails]);

  const setSelectedEmail = useCallback((email: Email | null) => {
    stableSetCurrentEmail(email);
  }, [stableSetCurrentEmail]);

  return {
    operations,
    loadFolderEmails,
    setSelectedEmail,
  };
};
